import { parseDimensions } from '@/lib/utils/dimensions';

const originalGuidance = {
  nl: 'Volg de afloop en aanleverinstructies van de productspecifieke werktekening.',
  en: 'Follow the bleed and artwork submission instructions in the product-specific template.',
  de: 'Beachten Sie die Beschnitt- und Druckdatenvorgaben der produktspezifischen Druckvorlage.',
  fr: 'Respectez le fond perdu et les consignes de préparation du fichier indiqués dans le gabarit spécifique au produit.',
} as const;

export function productTemplateGuidance(locale: string): string {
  return originalGuidance[locale.split('-')[0] as keyof typeof originalGuidance] || originalGuidance.en;
}

export function hasEditorSize(sizeValue: string | undefined): boolean {
  if (!sizeValue?.trim()) return false;
  const dimensions = parseDimensions(sizeValue);
  return Boolean(dimensions && dimensions.width > 0 && dimensions.height > 0);
}
